import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useMemo, useReducer } from "react";
import { useSafeContext } from "@aviv-unified-frontend/internal";
const OverlayOrchestratorContext = createContext(null);
const statusByType = {
    INIT: "initialized",
    DISABLE: "disabled",
    COMPLETE: "completed",
};
export const reducer = (state, action) => {
    const status = statusByType[action.type];
    if (status) {
        return {
            ...state,
            [action.payload]: status,
        };
    }
    return state;
};
const initialState = {
    consent: "initialized",
    "custom-banner": "pending",
    "adjust-banner": "pending",
    "google-one-tap": "pending",
    airship: "pending",
    qualtrics: "pending",
};
export const OverlayOrchestratorProvider = ({ children, }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const value = useMemo(() => ({ state, dispatch }), [state, dispatch]);
    return (_jsx(OverlayOrchestratorContext.Provider, { value: value, children: children }));
};
export const useOverlayOrchestrator = () => useSafeContext({
    package: "@aviv-unified-frontend/branded-shell",
    module: "overlayOrchestrator",
}, OverlayOrchestratorContext);
